import { Module, ActionContext } from 'vuex'
import { ProspectingCommonService, ProspectingResellingService } from '../services'
import { ProspectingState, RootState } from './state_models'

export const prospecting: Module<ProspectingState, RootState> = {
  namespaced: true,
  state: {
    optInEnabled: false,
    offeringEnabled: false,
    linkedSubAccountId: undefined,
  },
  getters: {
    getOfferingEnabled: (state: ProspectingState) => state.offeringEnabled,
    getOptInEnabled: (state: ProspectingState) => state.optInEnabled,
    getLinkedSubAccountId: (state: ProspectingState) => state.linkedSubAccountId,
  },
  mutations: {
    setOfferingEnabled: (state: ProspectingState, value: boolean) => {
      state.offeringEnabled = value
    },
    setOptInEnabled: (state: ProspectingState, value: boolean) => {
      state.optInEnabled = value
    },
    setLinkedSubAccountId: (state: ProspectingState, value: string) => {
      state.linkedSubAccountId = value
    },
  },
  actions: {
    async fetchOfferingEnabled(context: ActionContext<ProspectingState, RootState>, locationId: string) {
      try {
        let response
        if (locationId) {
          response = await ProspectingResellingService.getLocationResellingConfig(locationId)
        }
        const offeringEnabled = response?.offeringEnabled
        const optInEnabled = response?.companyCustomFields?.optInEnabled || false
        context.commit('setOfferingEnabled', offeringEnabled)
        context.commit('setOptInEnabled', optInEnabled)
      } catch (error) {
        return
      }
    },
    async fetchLinkedSubAccountId(context: ActionContext<ProspectingState, RootState>, companyId: string) {
      try {
        let response
        if (companyId) {
          response = (await ProspectingCommonService.getAgencySettings(companyId)) ?? {}
        }
        const linkedSubAccountId = response?.linkedSubAccount?.id
        context.commit('setLinkedSubAccountId', linkedSubAccountId)
      } catch (error) {
        return
      }
    },
  },
}
